import { useMemo } from 'react';
import { useUpdateEffect } from 'ahooks';
import {
  SemanticCOLORS,
  SemanticICONS,
} from 'semantic-ui-react/dist/commonjs/generic';

import { useAppDispatch, useAppSelector } from 'src/store';
import notification, { State } from 'src/store/ui/notification';

const useNotification = () => {
  const dispatch = useAppDispatch();
  const { type, message, activeKey, isOff } = useAppSelector(
    (state) => state.ui.notification,
  );

  useUpdateEffect(() => {
    const timeout = setTimeout(() => {
      action.off();
    }, 7000);

    return () => {
      clearTimeout(timeout);
    };
  }, [activeKey]);

  const state = useMemo(() => {
    const isOpen = !!(type && message);
    let color: SemanticCOLORS | undefined = undefined;
    let icon: SemanticICONS | undefined = undefined;

    switch (type) {
      case 'success':
        color = 'green';
        icon = 'check circle';
        break;
      case 'error':
        color = 'red';
        icon = 'times circle';
        break;
      case 'info':
        color = undefined;
        icon = 'info circle';
        break;
      case 'warning':
        color = 'orange';
        icon = 'warning sign';
    }

    return { type, message, isOpen, color, icon, isOff };
  }, [type, message]);

  const action = useMemo(
    () => ({
      on: (args: State) => {
        dispatch(notification.on(args));
      },
      off: () => {
        dispatch(notification.off());
      },
    }),
    [],
  );

  return [state, action] as const;
};

export default useNotification;
